import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { XDataEntity } from 'src/app/models/data-entities/x-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-x-data-entity-view',
    templateUrl: './x-data-entity-view.component.html',
    styleUrls: ['./x-data-entity-view.component.css'],
    standalone: false
})
export class XDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  xEntity: XDataEntity;

  ngOnInit() {
    this.xEntity = <XDataEntity>this.entity;
  }
}
